<div fxLayout="row">
    <div fxFlex="1 1 30%" fxLayout="column">
        <mat-radio-group class="display-data-type-radio-group" [(ngModel)]="selectedDisplayDataType" (change)="onDisplayDataTypeChange($event)">
            <mat-radio-button class="display-data-type-radio" value="rate">Rate</mat-radio-button>
            <mat-radio-button class="display-data-type-radio" value="df">Discount Factor</mat-radio-button>
        </mat-radio-group>
        <p-tree *ngIf="curveNodes" [value]="curveNodes" selectionMode="checkbox" [(selection)]="selectedCurveNodes"
            [propagateSelectionUp]="false" [propagateSelectionDown]="false" (onNodeSelect)="onCurveSelect($event)">
        </p-tree>

    </div>
    <div fxFlex="1 1 70%" id="curvechartdiv"></div>
</div>